const isAuthenticated = (configData) => {
  return !!configData?.ctas?.generic;
};

const isUserOrganizational = (configData) => {
  const userState = configData?.header?.userDetails?.state;
  return userState?.organizational;
};

const isSubscriptionActive = (configData) => {
  const userState = configData?.header?.userDetails?.state;
  return userState?.subscriptionActive;
};

const isOsanoAllowed = (configData, productCode) => {
  const osanoAppKey = configData.osanoAppKey;

  const isEnabledForUser = productCode !== "dhe" || isAuthenticated(configData);

  const isEnabledForOrganization =
    !isUserOrganizational(configData) || !isSubscriptionActive(configData);

  const isAllowed = !!(
    osanoAppKey &&
    isEnabledForUser &&
    isEnabledForOrganization
  );

  return isAllowed;
};

module.exports = {
  isAuthenticated,
  isOsanoAllowed
};
